(function () {
  "use strict";

  angular.module("sempraWebapp").component("pumps", {
    templateUrl: "app/facilityKarcherDetails/pumps/pumps.html",
    controller: pumps,
    bindings: {
      pumpsList: "<",
      activation: "&",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function pumps($mdDialog) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if(!changes.pumpsList.currentValue) {
        return;
      }
      vm.pumpsList = mapPumpData(changes.pumpsList.currentValue);
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.actuatePumpProgram = function(ev, dataToUpdate, parentId) {
      $mdDialog
          .show({
            controller: "ActuatePumpProgramsController",
            controllerAs: "vm",
            templateUrl:
                "app/karcherCustomDialogs/actuatePumpPrograms/actuatePumpPrograms.html",
            /* eslint-disable */
            parent: angular.element(document.body),
            /* eslint-enable */
            targetEvent: ev,
            locals: { data: dataToUpdate, parentId: parentId },
            clickOutsideToClose: false
          })
          .then(
              function (data) {
                vm.activation({ data: data, parentPointId: parentId });
              },
              function () {}
          );
    }

    function mapPumpData(data) {
      data.forEach(function (item) {
        for (var i = 0; i < item.programsList.length; i++) {
          for (var j = 0; j < item.programsList[i].feeds.length; j++) {
            if (item.programsList[i].feeds[j].reference === "NAME") {
              item.programsList[i].programName =
                item.programsList[i].feeds[j].currentValue;
            }
          }
          for (var k = 0; k < item.programsList[i].actuators.length; k++) {
            if (
              item.programsList[i].actuators[k].reference.includes("RUN_TIME")
            ) {
              item.programsList[i][
                item.programsList[i].actuators[k].reference
              ] = item.programsList[i].actuators[k].value;
              item.programsList[i][
                item.programsList[i].actuators[k].reference + "_ID"
              ] = item.programsList[i].actuators[k].id;
              item.programsList[i][
              item.programsList[i].actuators[k].reference + "_STATE"
                ] = item.programsList[i].actuators[k].state;
            }
          }
        }
      });
      return data;
    }
  }
})();
